import React from "react";
import {withRouter} from "react-router-dom";
import {getOrderInfo} from "./Service";
import {IonAlert, IonContent, IonPage} from "@ionic/react";
import {Helmet} from "react-helmet";
import MFooter from "../../components/MFooter";
import {getQueryVariable} from "../../utils/commonFunction";
import cookieUtil from "../../utils/cookieUtil";


class PayResult extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            imgUrl: require("../images/m91y/retrun_icon_03.png"),
            payOrderNum: '',
            payPrice: 0,
            payResultTip: '充值中……'
        }
    }

    componentDidMount() {
        let orderNum = getQueryVariable('OrderId');
        if (orderNum != null) {
            this.setState({payOrderNum: orderNum})
            this.cycleOrderStatus(orderNum);
        }
    }

    cycleOrderStatus = (orderNum) => {
        if (orderNum === "") {
            this.setState({
                isShowTip: true,
                showTipMsg: '请勿非法操作！'
            })
            return;
        }
        let round = 1;
        let that = this;
        let myVal = setInterval(function () {
            if (round < 6) {
                that.getOrderInfos(myVal);
            }
            round++;
        }, 1000)
    }

    getOrderInfos = (myVal) => {
        const {payOrderNum} = this.state;
        if (payOrderNum === "") {
            this.setState({
                isShowTip: true,
                showTipMsg: '请勿非法操作！'
            })
            return;
        }
        const urlParams = {
            'access_token': cookieUtil.has("access_token") ? cookieUtil.get("access_token") : '',
            'payOrderId': payOrderNum,
            'cardPay': '',
        }
        getOrderInfo(urlParams, true).then(ret => {
            if (ret.code === '10000') {
                const d = ret.data;
                if (d.status === 1) {
                    clearInterval(myVal);
                    this.setState({
                        imgUrl: require("../images/m91y/retrun_icon_01.png"),
                        payResultTip: "充值成功",
                        payPrice: d.amount
                    })
                } else {
                    this.setState({
                        imgUrl: require("../images/m91y/retrun_icon_02.png"),
                        payResultTip: "充值失败",
                        payPrice: d.amount
                    })
                }
            } else {
                this.setState({
                    imgUrl: require("../images/m91y/retrun_icon_02.png"),
                    payResultTip: "充值失败"
                })
            }
        }).catch(err => {
            console.log(err)
        });
    }

    closeTipBox = () => {
        this.setState({
            isShowTip: false,
            showTipMsg: null,
        })
    }

    render() {
        return (
            <IonPage>
                <meta name="viewport" content="width=750,target-densitydpi=device-dpi,user-scalable=no"/>
                <meta name="format-detection" content="telephone=no"/>
                <meta name="apple-mobile-web-app-capable" content="yes"/>
                <meta name="apple-mobile-web-app-status-bar-style" content="black"/>
                <IonContent fullscreen>
                    <Helmet placeholder={""}>
                        <link rel="stylesheet" href="//m.91y.com/templets/default/20190813/css/91y_phone.css"
                              type="text/css"/>
                        <link rel="stylesheet"
                              href="//m.91y.com//templets/default/20190813/css/91y_public.css?v=2021012801"
                              type="text/css"/>
                    </Helmet>
                    <div className="p-box">
                        <div className="t-recharge">
                            <div className="r-results">
                                <em className="r-results-icon">
                                    <img src={this.state.imgUrl} alt={""}/></em>
                                <p className="r-results-txt">{this.state.payResultTip}</p>
                            </div>
                            <div className="r-account">
                                <em className="r-title">订单号：</em>
                                <span className="r-cot"><p className="ordertrade">{this.state.payOrderNum}</p></span>
                            </div>
                            <div className="r-account">
                                <em className="r-title">充值金额：</em>
                                <span className="r-cot">
                                    <p><b className="yellow jspricestr">{this.state.payPrice}</b>元</p>
                                </span>
                            </div>
                        </div>
                        <MFooter title={"充值"} isJumpLogin={false}/>
                    </div>
                </IonContent>
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
}

export default withRouter(PayResult);
